import React from 'react';
import { Spin, Progress, Typography } from 'antd';

const { Text } = Typography;

export function QuotaBadge({ quota, pct, label = '조회', noLimitText }) {
    if (quota.loading) {
        return (
            <div
                className="quota-badge-wrap"
                style={{ display: 'flex', alignItems: 'center', padding: '0 8px' }}
            >
                <Spin size="small" />
            </div>
        );
    }

    const unlimited =
        quota.unlimited || quota.remaining === -1 || (!quota.loading && Number(quota.limit) <= 0);

    const color = pct >= 90 ? '#ff4d4f' : pct >= 70 ? '#faad14' : '#2e5bff';

    return (
        <div
            className="quota-badge-wrap"
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '3px',
                minWidth: '110px',
                textAlign: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px',
                    lineHeight: 1,
                }}
            >
                <span style={{ fontSize: '10px', color: '#8c8c8c', whiteSpace: 'nowrap' }}>
                    {label}
                </span>
                <span
                    style={{
                        fontSize: '11px',
                        fontWeight: 600,
                        color: unlimited ? '#52c41a' : color,
                        whiteSpace: 'nowrap',
                        position: 'relative',
                        top: '-1px',
                    }}
                >
                    {unlimited ? (
                        <>{noLimitText ?? '무제한'}</>
                    ) : (
                        <>
                            {quota.used}/{quota.limit + (quota.bonus || 0)}
                            {' · '}
                            {quota.remaining}건
                        </>
                    )}
                </span>
            </div>
            {!unlimited && (
                <Progress
                    percent={pct}
                    showInfo={false}
                    size={['100%', 6]}
                    strokeColor={color}
                    trailColor="#f0f0f0"
                />
            )}
        </div>
    );
}
